import { addSeconds, differenceInSeconds } from 'date-fns';

export const urlLifetimeSec = 86400;
export class ExpiringUrl {
    private _url: string;
    private expiresAt = new Date();

    constructor(url: string, options = { expiresInSec: urlLifetimeSec }) {
        this._url = url;
        this.expiresAt = addSeconds(new Date(), options.expiresInSec);
    }

    get url() {
        return differenceInSeconds(this.expiresAt, new Date()) > 0 ? this._url : undefined;
    }
}
